import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGeneroOSexoConsulta } from '../../shared/interfaces/sisben/sisben';

@Injectable({
  providedIn: 'root'
})
export class GeneroOSexoService {
  private readonly baseUrl = `${environment.apiUrl}/api/datasets-dinamicos/sisben/genero-o-sexo`;

  constructor(private readonly http: HttpClient) { }

  findAll(): Observable<IGeneroOSexoConsulta[]> {
    return this.http.get<IGeneroOSexoConsulta[]>(this.baseUrl);
  }
}
